export default "__VITE_ASSET__b223138d__"